import { sh } from '@tpluscode/rdf-ns-builders';
import ConstraintComponent from './ConstraintComponent.js';
export class NodeKindConstraintComponent extends ConstraintComponent {
    constructor(__createFilterExpression) {
        super(sh.NodeKindConstraintComponent);
        this.__createFilterExpression = __createFilterExpression;
    }
    static *fromShape(shape) {
        const values = shape.get(sh.nodeKind);
        if (values) {
            for (const value of values) {
                if (!('pointer' in value)) {
                    continue;
                }
                const nodeKind = value.pointer.term;
                let createFilterExpression;
                switch (nodeKind.value) {
                    case 'http://www.w3.org/ns/shacl#IRI':
                        createFilterExpression = is.bind(null, 'iri');
                        break;
                    case 'http://www.w3.org/ns/shacl#IRIOrLiteral':
                        createFilterExpression = alternative.bind(null, ['iri', 'literal']);
                        break;
                    case 'http://www.w3.org/ns/shacl#BlankNodeOrIRI':
                        createFilterExpression = alternative.bind(null, ['blank', 'iri']);
                        break;
                    case 'http://www.w3.org/ns/shacl#Literal':
                        createFilterExpression = is.bind(null, 'literal');
                        break;
                    case 'http://www.w3.org/ns/shacl#BlankNodeOrLiteral':
                        createFilterExpression = alternative.bind(null, ['blank', 'literal']);
                        break;
                    case 'http://www.w3.org/ns/shacl#BlankNode':
                        createFilterExpression = is.bind(null, 'blank');
                        break;
                }
                if (createFilterExpression) {
                    yield new NodeKindConstraintComponent(createFilterExpression);
                }
            }
        }
    }
    buildNodeShapePatterns({ focusNode }) {
        return [this.__buildFilter(focusNode)];
    }
    buildPropertyShapePatterns({ valueNode }) {
        return [this.__buildFilter(valueNode)];
    }
    __buildFilter(subject) {
        return {
            type: 'filter',
            expression: this.__createFilterExpression(subject),
        };
    }
}
function is(what, value) {
    return {
        type: 'operation',
        operator: `is${what}`,
        args: [value],
    };
}
function alternative([left, right], value) {
    return {
        type: 'operation',
        operator: '||',
        args: [
            is(left, value),
            is(right, value),
        ],
    };
}
